import React, {useEffect, useMemo, useRef, useState} from "react";
import { useTranslation } from 'react-i18next';
import {Slider} from "antd";

// Components
import TextWithLinks from "sharedComponents/TextWithLinks";

// Hooks
import useDropoutSurveyField from "Hooks/useDropoutSurveyField";

// Utils
import validateExplanationField from "utils/validateExplanationField";
import {findDOMNode} from "react-dom";


const Range = ({fieldData, getAnswer, handleChangeSurveyCompletionStatus, mandatoryRefs, disabled = false}) => {
    const explanationRef = useRef();
    const rangeRef = useRef();
    const [showError, SetShowError] = useState('');
    const [rangeVal, SetRangeVal] = useState(null);
    const [showExplanation, SetShowExplanation] = useState(false);
    const { t } = useTranslation();
    useDropoutSurveyField(rangeVal, '', handleChangeSurveyCompletionStatus);

    const marks = useMemo(() => {
        let resultMarks = {}
        const rangeNumbers = JSON.parse(fieldData.type_content)?.added_range_numbers;
        rangeNumbers && rangeNumbers.forEach((item) => resultMarks[item] = String(Math.round(item)));
        return resultMarks;
    }, [fieldData]);

    useEffect(() => {
        if (getAnswer.constructor !== Boolean) {
            getAnswer(prevState => ({
                ...prevState,
                [fieldData.id]: {answer: rangeVal || '', explanation: explanationRef.current.value}
            }));

            const explanationValidation = validateExplanationField(explanationRef.current?.value);
            explanationValidation && SetShowError(explanationValidation);

            (fieldData.mandatory && !rangeVal) && SetShowError('Required');
        }
    }, [getAnswer, rangeVal, fieldData]);

    useEffect(() => {
        if (fieldData?.answers?.answer) {
            SetShowExplanation(!!fieldData?.answers?.explanation);
            explanationRef.current.value = fieldData?.answers?.explanation;
            SetRangeVal(fieldData?.answers?.answer);
        }
    }, []);

    useEffect(() => {
        const fieldNode = findDOMNode(rangeRef.current);
        if (fieldData.mandatory) {
            if (Array.isArray(mandatoryRefs) && !mandatoryRefs.includes(fieldNode)) {
                mandatoryRefs.push(fieldNode);
            }
        }
    }, [fieldData]);

    const handleChangeRange = (value) => {
        if (!!value) {
            const explanationValidation = validateExplanationField(explanationRef.current?.value);
            showError && SetShowError(explanationValidation);
            !!fieldData.explanation && SetShowExplanation(true);
        } else {
            SetShowExplanation(false);
            explanationRef.current.value = ""
            SetShowError('');
            const fieldNode = findDOMNode(rangeRef.current);
            if (fieldData.mandatory) {
                if (Array.isArray(mandatoryRefs) && !mandatoryRefs.includes(fieldNode)) {
                    mandatoryRefs.unshift(fieldNode);
                }
            }
        }

        SetRangeVal(value || null);
    };

    const handleChangeExplanation = (e) => {
        SetShowError(validateExplanationField(e.target.value));
    };

    return (<div
        ref={rangeRef}
        className={`single_sect range_sect ${showError ? "invalid" : ""}`}
    >
        <h3 className="single_sect_primary_text">
            {fieldData.label}
            {!!fieldData.mandatory && <sup>*</sup>}
        </h3>
        <TextWithLinks className="single_sect_secondary_text">
            {fieldData.description}
        </TextWithLinks>
        <div className="rate_with_explanation">
            <Slider
                defaultValue={fieldData?.answers?.answer}
                className="slider_sect"
                onChange={handleChangeRange}
                marks={marks}
                min={0}
                max={JSON.parse(fieldData.type_content)?.added_range_numbers?.[1]}
                disabled={disabled}
            />
            <div
                className={`input_field hidden_input_field ${showExplanation ? "show" : "hide"}`}
            >
                <input
                    ref={explanationRef}
                    type="text"
                    onChange={handleChangeExplanation}
                    placeholder={t("Explain your choice (optional)...")}
                    disabled={disabled}
                />
            </div>
        </div>
        <div className="error_sect">
            {showError}
        </div>
    </div>)
}

export default React.memo(Range);
